import { useState } from 'react'
import { useFavoritePlayer } from '@/hooks/useFavoritePlayer'
import { useRoster } from '@/hooks/useRoster'
import { usePlayerSeasonData } from '@/hooks/usePlayerSeasonData'
import { PlayerSelector } from '@/features/player-selector/PlayerSelector'
import { PlayerStatus } from '@/features/player-status/PlayerStatus'
import { VideoSection } from '@/features/video-section/VideoSection'
import { MOCK_VIDEOS } from '@/lib/mockPlayers'
import styles from './App.module.css'

type View = 'selector' | 'status'

export function App() {
  const { favoritePlayerId, setFavoritePlayer } = useFavoritePlayer()
  const roster = useRoster()
  const [view, setView] = useState<View>(favoritePlayerId ? 'status' : 'selector')
  const seasonData = usePlayerSeasonData(view === 'status' ? favoritePlayerId : null)

  const handleSelect = (id: string) => {
    setFavoritePlayer(id)
    setView('status')
  }

  const handleBack = () => {
    setView('selector')
  }

  const selectedVideos = favoritePlayerId ? (MOCK_VIDEOS[favoritePlayerId] ?? []) : []

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          {view === 'status' && (
            <button className={styles.backButton} onClick={handleBack} aria-label="選手選択に戻る">
              ‹ 戻る
            </button>
          )}
          <h1 className={styles.title}>推し選手ビューア</h1>
        </div>
      </header>

      <main className={styles.main}>
        {view === 'status' && favoritePlayerId ? (
          <>
            <PlayerStatus data={seasonData.data} loading={seasonData.loading} error={seasonData.error} />
            {seasonData.data && (
              <VideoSection videos={selectedVideos} playerName={seasonData.data.profile.name} />
            )}
          </>
        ) : (
          <PlayerSelector
            players={roster.players}
            loading={roster.loading}
            error={roster.error}
            selectedId={favoritePlayerId}
            onSelect={handleSelect}
          />
        )}
      </main>

      <footer className={styles.footer}>
        <p className={styles.disclaimer}>
          本アプリは NPB（日本野球機構）公式のサービスではありません。個人の私的利用を目的とした非公式ツールです。
        </p>
      </footer>
    </div>
  )
}
